import Header from '../../components/Header'
import DesempenhoGeralUsuario from '../../components/DesempenhoGeralUsuario'
import Animais from '../../components/Animais'
import CardMMCoins from '../../components/CardMMCoins'
import CardAnimalRelatorio from '../../components/CardAnimalRelatorio'
import BackgroundSection from '../../components/BackgroundSection'
import Ranking from '../../components/Ranking'
import styled from 'styled-components'
import { useState } from 'react'
import { useEffect } from 'react'
import '../../app.css'
import { post } from '../../services/api'

const App = styled.div`
    text-align: center;
  `

const Container = styled.div`
    width: 100%;
`

// Relatórios
const vacaLeiteira = 1;
const painelBordo = 2;
const trv = 3;
const oceanoAzul = 4;
const oceanoAzulRede = 5;

function Home() {
    const [cargo, setCargo] = useState(null);
    const [vendedor, setVendedor] = useState(null);
    const [regiao, setRegiao] = useState(null);
    const [mesAnoRelatorio, setMesAnoRelatorio] = useState(null);
    const [vendedorAuxiliar, setVendedorAuxiliar] = useState(null);
    const [mesAnoAuxiliar, setMesAnoAuxiliar] = useState(null);
    const [changeVendedor, setChangeVendedor] = useState(null);
    const [changeMesAno, setChangeMesAno] = useState(null);
    const [vendedorRanking, setVendedorRanking] = useState(null);
    const [permissoesRelatorios, setPermissoesRelatorios] = useState({});
    const [loadingDados, setLoadingDados] = useState({});
    const [pontuacaoTotalRealizada, setPontuacaoTotalRealizada] = useState(0);
    const [pontuacaoTotalProjetada, setPontuacaoTotalProjetada] = useState(0);

    useEffect(() => {
        setVendedor(null);
    }, [vendedor]);

    useEffect(() => {
        setVendedorRanking(null);
    }, [vendedorRanking]);

    useEffect(() => {
        exibirRelatoriosPorPermissao();
    }, [cargo]);

    async function exibirRelatoriosPorPermissao() {
        let relatorios = [];

        if (cargo === 'GERENTE_REGIONAL') {
           relatorios = [oceanoAzulRede];
        }

        if (cargo === 'GERENTE_LOJA') {
            relatorios = [trv];
        }

        if (cargo === 'VENDEDOR') {
            relatorios = [trv];
        }

        const idsRelatorios = relatorios;
        const permissoes = {};

        for (let idRelatorio of idsRelatorios) {
            const permissao_encontrada = await consultaPermissaoRelatorio(idRelatorio);
            permissoes[idRelatorio] = permissao_encontrada;
        }

        setPermissoesRelatorios(permissoes);
    }

    async function consultaPermissaoRelatorio(idRelatorio) {
        const idVendedorUsuario = localStorage.getItem("idvendedorusuario");

        try {
            let permissao = false;
            const response = await post('/vendedores/permissaorelatorio', {
                vendedor: idVendedorUsuario,
                cargo: cargo,
                relatorio: idRelatorio,
            });
            
            if (response.sucesso) {
                permissao = response.permissao_encontrada;
            }
            
            return permissao;

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
            return false;
        }
    }

    const handleFiltrarClick = (idVendedor, mesAno, regiao) => {
        setPontuacaoTotalRealizada(0);
        setPontuacaoTotalProjetada(0);
        setMesAnoRelatorio(mesAno);
        setVendedor(idVendedor);
        setVendedorRanking(idVendedor);
        setRegiao(regiao);
    };

    const handleCargoChange = (cargo, idvendedor) => {
        setCargo(cargo);
        setChangeVendedor(idvendedor);
        setRegiao(idvendedor);
    };

    const handleMesAnoChange = (mesAno) => {
        setChangeMesAno(mesAno);
    };

    const loadingDadosAnimal = (idAnimal, loading) => {
        setLoadingDados((prevLoading) => ({
            ...prevLoading,
            [idAnimal]: loading,
        }));
        setVendedorAuxiliar(vendedor);
        setMesAnoAuxiliar(mesAnoRelatorio);
    };

    const handlePontuacaoAtualizada = (pontuacaoRealizada, pontuacaoProjetada) => {
        
        setPontuacaoTotalRealizada(prev => prev + pontuacaoRealizada);
        setPontuacaoTotalProjetada(prev => prev + pontuacaoProjetada);
      };

    const load = Object.values(loadingDados).every(value => value === true);

    return (
        <App>
            <Header type="home" onFiltrarClick={handleFiltrarClick} dadosCarregados={load} cargoChange={handleCargoChange} mesAnoChange={handleMesAnoChange} />
            <BackgroundSection imageName="img">
                <Container>
                    <DesempenhoGeralUsuario mesAno={mesAnoRelatorio} idVendedor={vendedor} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} pontuacaoRealizadaTotal={pontuacaoTotalRealizada} pontuacaoProjetadaTotal={pontuacaoTotalProjetada} dadosCarregados={load}/>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pt-12 font-poppins">
                        {cargo == 'GERENTE_LOJA' && (
                            <>
                                <CardAnimalRelatorio idRelatorio={painelBordo} nomeRelatorio="Painel de Bordo" descricaoRelatorio="Verifica Indicador" mesAno={mesAnoAuxiliar}
                                    status="Este item contém um Dashboard com os indicadores de Valor Presente, Juros e Serviços" />
                                <Animais idAnimal={1} nomeAnimal="Leão" indicadorAnimal="Mercantil" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={2} nomeAnimal="Tigre" indicadorAnimal="Juros" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={3} nomeAnimal="Pinguim" indicadorAnimal="Serviços" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={11} nomeAnimal="Zebra Velha" indicadorAnimal="Inadimplência 180" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={10} nomeAnimal="Suricato" indicadorAnimal="Soluções Financeiras" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <CardAnimalRelatorio idRelatorio={oceanoAzul} nomeRelatorio="Oceano Azul" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} idVendedor={changeVendedor} cargo={cargo}
                                    status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                            </>
                        )}

                        {(cargo == 'VENDEDOR' || cargo == null) && (
                            <>
                                <Animais idAnimal={1} nomeAnimal="Leão" indicadorAnimal="Mercantil" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={2} nomeAnimal="Tigre" indicadorAnimal="Juros" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={3} nomeAnimal="Pinguim" indicadorAnimal="Serviços" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={5} nomeAnimal="Zebrinha" indicadorAnimal="Inadimplência" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <CardAnimalRelatorio idRelatorio={vacaLeiteira} nomeRelatorio="Vaca Leiteira" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} idVendedor={changeVendedor}
                                    status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                                <CardMMCoins idVendedor={vendedorAuxiliar} changeMesAno={changeMesAno} changeVendedor={changeVendedor}/>
                                {permissoesRelatorios[trv] && (
                                    <CardAnimalRelatorio idRelatorio={trv} nomeRelatorio="Simulador de Comissão" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} idVendedor={changeVendedor} cargo={cargo}
                                        status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                                )}
                                <CardAnimalRelatorio idRelatorio={oceanoAzul} nomeRelatorio="Oceano Azul" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} idVendedor={changeVendedor} cargo={cargo}
                                    status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                               
                            </>
                        )}

                        {cargo == 'GERENTE_REGIONAL' && (
                            <>
                                <CardAnimalRelatorio idRelatorio={painelBordo} nomeRelatorio="Painel de Bordo" descricaoRelatorio="Verifica Indicador" mesAno={mesAnoAuxiliar}
                                    status="Este item contém um Dashboard com os indicadores de Valor Presente, Juros e Serviços" />
                                <Animais idAnimal={1} nomeAnimal="Leão" indicadorAnimal="Mercantil" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={2} nomeAnimal="Tigre" indicadorAnimal="Juros" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={3} nomeAnimal="Pinguim" indicadorAnimal="Serviços" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={4} nomeAnimal="Girafa" indicadorAnimal="Web Relacionamento" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={6} nomeAnimal="Hipopótamo" indicadorAnimal="Produtos St.Vermelho" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={7} nomeAnimal="Jaguar" indicadorAnimal="Plano Controle" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={8} nomeAnimal="Vaca Leiteira" indicadorAnimal="MCG + Juros" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <Animais idAnimal={10} nomeAnimal="Suricato" indicadorAnimal="Soluções Financeiras" mesAno={mesAnoRelatorio} idVendedor={vendedor} loading={loadingDadosAnimal} changeVendedor={changeVendedor} changeMesAno={changeMesAno} cargo={cargo} regiao={regiao} onPontuacaoAtualizada={handlePontuacaoAtualizada}/>
                                <CardAnimalRelatorio idRelatorio={oceanoAzul} nomeRelatorio="Oceano Azul" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} regiao={regiao} idVendedor={changeVendedor} cargo={cargo}
                                    status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                                {permissoesRelatorios[oceanoAzulRede] && (
                                    <CardAnimalRelatorio idRelatorio={oceanoAzulRede} nomeRelatorio="Oceano Azul Rede" descricaoRelatorio="Verifica Indicador" mesAno={changeMesAno} regiao={regiao} idVendedor={changeVendedor} cargo={cargo}
                                        status="Este item não conta em sua excelência, serve como relatório de acompanhamento." />
                                )}
                            </>
                        )}
                    </div>
                </Container>
            </BackgroundSection>
            <Ranking mesAno={mesAnoRelatorio} idVendedor={vendedorAuxiliar} changeMesAno={changeMesAno} changeVendedor={changeVendedor} cargo={cargo} regiao={regiao} idVendedorAuxiliar={vendedor} />
        </App>
    );
}

export default Home
